module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": ""
    }
  }, [_c('c-confirm-dialog-alunos', {
    attrs: {
      "titulo": "Ausência de alunos de graduação e/ou pós-graduação na equipe"
    },
    on: {
      "yes": function($event) {
        return _vm.redirecionaAbaEquipe()
      }
    },
    model: {
      value: (_vm.dialogAusenciaAlunos),
      callback: function($$v) {
        _vm.dialogAusenciaAlunos = $$v
      },
      expression: "dialogAusenciaAlunos"
    }
  }, [_vm._v("\n        A ação de extensão ainda não possui estudantes de graduação e/ou pós-graduação cadastrados, o que é necessário para que a ação possa ser atualizada no sistema. Realize o cadastro na aba EQUIPE.\n      ")]), _vm._v(" "), ((this.administrador === true || this.usuarioPROEX === true) && this.projeto.suspensoes === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "alertaSuspensao",
    attrs: {
      "dense": "",
      "type": "info",
      "color": "#00796b",
      "outlined": ""
    }
  }, [_vm._v("\n            Esta ação possui períodos de suspensão cadastrados, para maiores detalhes verificar a aba EXTENSÃO.\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Título",
      "value": this.projeto.titulo
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Número",
      "value": this.projeto.idProjeto
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Situação",
      "value": this.projeto.situacao.descricao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Tipo de público-alvo",
      "value": this.projeto.tipoPublico.descricao
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Público-alvo estimado",
      "value": this.projeto.publicoAlvo || ' '
    }
  })], 1)], 1), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39729) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Carga horária do curso",
      "value": this.projeto.cargaHoraria || ' '
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 44194) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Carga horária do curso",
      "value": this.projeto.cargaHoraria || ' '
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 44195) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Carga horária da oficina",
      "value": this.projeto.cargaHoraria || ' '
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39730) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Carga horária do evento",
      "value": this.projeto.cargaHoraria || ' '
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data de início",
      "value": this.projeto.dataInicio
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Data de conclusão",
      "value": this.projeto.dataConclusao
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Palavra-chave 1",
      "value": this.projeto.palavraChave01 || ' '
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Palavra-chave 2",
      "value": this.projeto.palavraChave02 || ' '
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Palavra-chave 3",
      "value": this.projeto.palavraChave03 || ' '
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Palavra-chave 4",
      "value": this.projeto.palavraChave04 || ' '
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-readonly-field', {
    attrs: {
      "label": "Resumo",
      "value": this.projeto.resumo,
      "align": "justify"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "ClassificacoesProjeto",
      "editar": this.permissaoEditar(this.projeto.situacao.item) ? 'EditarInformacoes' : null,
      "nome_editar": "Editar",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e7561fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projeto/projeto-formulario.vue
// module id = 459
// module chunks = 0